import { useTranslation } from "react-i18next";
import { Autocomplete, Button, TextField } from "@mui/material";
import { fetchAnimalList, fetchHerdSettings, fetchUserHerds } from "../../services/homeService";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { setAnimalList, setAnimalListLoaded, setSelectedHerd, setShowAnimalList, setShowHerdSelector, setShowSettingsModal } from "../../store/slices/appSlice";
import { UserHerdDto } from "../../generated/tsClient";
import { Col, Row } from "reactstrap";

function HerdSelector(props: any) {
    const dispatch = useAppDispatch();
    const { t } = useTranslation(["texts", "errors"]);
    const userHerds = useAppSelector((state) => state.app.userHerds);
    const selectedHerd = useAppSelector((state) => state.app.selectedHerd);
    const [listOpen, setListOpen] = useState(false);
    const [selectedListHerd, setSelectedListHerd] = useState<UserHerdDto | null>(selectedHerd);
    const [inputValue, setInputValue] = useState<string>('');

    useEffect(() => {
        if (userHerds == null)
            fetchUserHerds();
        else if (userHerds.length === 1) {
            handleHerdSelected(userHerds[0]);
        }
    }, [userHerds]);

    const handleClick = () => {
        if (selectedListHerd != null) {
            handleHerdSelected(selectedListHerd);
        }
    };

    const handleHerdSelected = (selectedHerd : UserHerdDto) => {
        const animalList = localStorage.getItem("mobilink_animalList_" + selectedHerd.idkar);
        const animalListLoaded = localStorage.getItem("mobilink_animalList_loaded_" + selectedHerd.idkar);
        if (animalList != null) {
            dispatch(setAnimalList(JSON.parse(animalList)));
            if (animalListLoaded != null)
                dispatch(setAnimalListLoaded(JSON.parse(animalListLoaded)));
        }
        else {
            dispatch(setAnimalList(null));
            fetchAnimalList(selectedHerd.idkar);
        }

        fetchHerdSettings(selectedHerd.idkar);
        dispatch(setSelectedHerd(selectedHerd));
        dispatch(setShowHerdSelector(false));
        dispatch(setShowSettingsModal(false));
        dispatch(setShowAnimalList(true));
    }

    const handleInputChange = (v: string) => {
        if (v.length < 4)
            setListOpen(false);
        else if (selectedListHerd == null || v !== selectedListHerd.idkar.toString().padStart(7, '0') + " " + (selectedListHerd.custName ?? ""))
            setListOpen(true);
        setInputValue(v);
    };

    const handleOnOpen = () => {
        if (inputValue.length > 3)
            setListOpen(true);
        else
            setListOpen(false);
    };

    return (
        <div>
            {userHerds != null && ( 
                <div>
                    <Row>
                        <Col>{t("Herd.Herd")}</Col>
                    </Row>
                    <Row>
                        <Col xs="9" className="herd-select-autocomplete">
                            <Autocomplete
                                options={userHerds}
                                getOptionLabel={(herd) => herd.idkar.toString().padStart(7, '0') + " " + (herd.custName ?? "")}
                                renderInput={(params) => <TextField {...params} />}
                                onChange={(event: any, selectedHerd: UserHerdDto | null) => {
                                    setSelectedListHerd(selectedHerd);
                                }}
                                forcePopupIcon={false}
                                inputValue={inputValue}
                                onInputChange={(e, v) => { handleInputChange(v) }}
                                open={listOpen}
                                onClose={() => setListOpen(false)}
                                onOpen={() => handleOnOpen}
                                value={selectedListHerd}
                                isOptionEqualToValue={(option, value) =>  option.idkar === value.idkar}
                            />
                        </Col>
                        <Col xs="3">
                            <Button
                                variant="contained"
                                className="btn-primary"
                                onClick={handleClick}
                                disabled={selectedListHerd == null }
                            >
                                {t("Herd.Load")}
                            </Button>
                        </Col>
                    </Row>
                </div>
            )}
        </div>
    );
}

export default HerdSelector;